import React from 'react';
import { Button } from 'antd';
import { UpOutlined, DownOutlined } from '@ant-design/icons';
import { t } from 'i18next';
import {GetClientType} from "../../../config";
const ShowMoreButton = ({  profileType, showMoreOptions, setShowMoreOptions }) => {
    if (GetClientType() !== "3dmax" || profileType !== "all") return null;

    return (
        <Button
            type="primary"
            className='show-more-button'
            onClick={() => setShowMoreOptions(!showMoreOptions)}
            icon={showMoreOptions ? <UpOutlined /> : <DownOutlined />}
        >
            {showMoreOptions ? t('product.show_less') : t('product.show_more')}
        </Button>
    );
};

export default ShowMoreButton;
